/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { setAllDropDownField } from "../utils/setAllDropDownField";
import inidividualTasklistFormData from "../data/IndividualMemberTable.Data";
import FormCreator from "../../../components/Forms/FormCreator";
import { useLazyGetAllDropdownsForIndividualMembersQuery } from "../../../app/services/Individual/IndividualTaskListApi";
import ModuleLoader from "../../../components/ui/moduleLoader/ModuleLoader";

const IndividualMemberSearchForm = forwardRef((props, ref) => {
    const searchFormRef = useRef();
    const [searchFormData, SetSearchForm] = useState(inidividualTasklistFormData);

    const [getAllDropDowns, {
        data: dropdownResponse,
        isSuccess: isSuccess,
        isLoading: isLoading,
    }] = useLazyGetAllDropdownsForIndividualMembersQuery();

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const searchFormResponse = searchFormRef.current.getFormData();
                return searchFormResponse;
            }
            return null;
        }
    }));

    useEffect(() => {
        if (!isLoading && isSuccess && dropdownResponse) {
            setAllDropDownField(dropdownResponse)
        }
    }, [isLoading, isSuccess, dropdownResponse])

    useEffect(() => { getAllDropDowns() }, [])

    return (isSuccess ? <FormCreator ref={searchFormRef} {...searchFormData} /> : <ModuleLoader />)

})

export default IndividualMemberSearchForm